export default __webpack_public_path__ + "static/media/Design.c7e9de20.png";